module.exports = __webpack_public_path__ + "images/emails/hero/signup@2x-8f5b5a63.png";